import styled from 'styled-components';

export const DiffIconBox = styled.div`
  font-size: 11px;
  padding: 3px;
  border-radius: 4px;
  color: #fff;
`;
